// 统一处理 config，支持回调
export var getCommonCfg = function (cfg, item, graph) {
    if (typeof cfg === 'function') {
        return cfg(item, graph);
    }
    return cfg;
};
